<mat-form-field fxFlex="100">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    [value]="value"
    [disabled]="disabled || loading"
    [required]="required"
    [placeholder]="placeholder"
    [compareWith]="compareByCode"
    (selectionChange)="changeValue($event.value)"
  >
    <mat-option [value]="null">
      Brak
    </mat-option>

    <mat-option *ngIf="loading" disabled>
      Ładowanie kodów...
    </mat-option>

    <mat-option *ngIf="!loading && !filteredItems.length" disabled>
      Brak kodów dla OFWCA przypisanych do placówki
    </mat-option>

    <mat-option
      *ngFor="let item of filteredItems"
      [value]="item.code"
    >
      <div class="affiliate-code-option">
        <div class="affiliate-code-option__main">
          <strong>{{ item.code }}</strong>

          <span
            *ngIf="item.main"
            class="affiliate-code-option__badge">
            Główny
          </span>
        </div>

        <div class="affiliate-code-option__meta">
          {{ getOptionLabel(item) }}
        </div>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
